import React from 'react';
import { Filter, BulkDeleteButton, TopToolbar, List, Edit, Datagrid, TextField, EditButton, ReferenceInput, SelectInput, SimpleForm, TextInput, required, } from 'react-admin';
import ExtraHrsButton from './ExtraHrsButton';
import { useMediaQuery, Typography } from '@material-ui/core';
import CreateFeeReminderEmailButton from './CreateFeeReminderEmailButton';
import MyTab from './mytab';
import SendEmailButton from './SendEmailButton';
import SetPaidButtonCash from './SetPaidButtonCash';
import SetPaidButtonCheck from './SetPaidButtonCheck';
import { getYears } from './utils';



const Aside = ({ data, ids }) => {
    // console.log(data, ids);
    var numrcpt = ids.map(id => data[id]).reduce((numrcpt, rec) => {
        return numrcpt + 1
    }, 0);
    var btottut = ids.map(id => data[id]).reduce((btottut, rec) => {
        var tut = parseFloat(rec.Amt)
        var ramt = parseFloat(rec.Regamt)
        var mamt = parseFloat(rec.Materialamt)
        var ehrs = parseFloat(rec.ExtraHrs)
        var lFee = parseFloat(rec.LateFee)
        if (!isNaN(tut)) {
            if (!isNaN(ehrs)) {
                tut = tut + ehrs
            }
            if (!isNaN(lFee)) {
                tut = tut + lFee
            }
            return btottut + tut
        } else if (!isNaN(ramt)) {
            return btottut + ramt
        } else if (!isNaN(mamt)) {
            return btottut + mamt
        }
    }, 0.0);
    var ptottut = ids.map(id => data[id]).reduce((ptottut, rec) => {
        var pamt = parseFloat(rec.AmtPaid)
        if (!isNaN(pamt)) {
            return ptottut + pamt
        } else {
            return ptottut
        }
    }, 0.0);
    return (
        <div style={{ width: 200, margin: '1em' }} >
            <Typography >Details:</Typography>
            <Typography variant="body1">
                <br />
                <Typography ># of receipts</Typography>
                {numrcpt}
                <br />
                <Typography >Billed Total Amount</Typography>
                ${btottut}
                <br />
                <Typography >Paid Total Amount</Typography>
                ${ptottut}
            </Typography>
        </div >
    );
}



const ReceiptFilter = (props) => (
    <Filter {...props}>
        <SelectInput alwaysOn label="Month" validate={required()} source="Month" allowEmpty={false} choices={[
            { id: 'All', name: 'All' },
            { id: 0, name: 'Jan' },
            { id: 1, name: 'Feb' },
            { id: 2, name: 'Mar' },
            { id: 3, name: 'Apr' },
            { id: 4, name: 'May' },
            { id: 5, name: 'Jun' },
            { id: 6, name: 'Jul' },
            { id: 7, name: 'Aug' },
            { id: 8, name: 'Sep' },
            { id: 9, name: 'Oct' },
            { id: 10, name: 'Nov' },
            { id: 11, name: 'Dec' },
        ]} />
        <SelectInput alwaysOn label="Year" validate={required()} source="Year" allowEmpty={false} choices={getYears()} />
        <SelectInput alwaysOn label="Type" validate={required()} source="RcptType" allowEmpty={false} choices={[
            { id: 'All', name: 'All' },
            { id: 'registration', name: 'registration' },
            { id: 'materialfee', name: 'materialfee' },
            { id: 'tuition', name: 'tuition' },
            { id: 'generic', name: 'generic' },
            { id: 'latefee', name: 'latefee' },
        ]} />
        <SelectInput alwaysOn label="Paid" validate={required()} source="Paid" allowEmpty={false} choices={[
            { id: 'All', name: 'All' },
            { id: 'Y', name: 'Y' },
            { id: 'N', name: 'N' },
        ]} />
        <ReferenceInput alwaysOn label="Student ID" source="id" reference="Students" filter={{ FEStatus: "Active:Pending" }} sort={{ field: 'Sname', order: 'ASC' }}>
            <SelectInput optionText={(record) => { let val = record.id + "-" + record.Sname; return val; }} />
        </ReferenceInput>
        {/* <TextInput alwaysOn label="Student ID" source="SID" /> */}
    </Filter >
);

// export const ReceiptCreate = (props) => (
//     <Create {...props}>
//     <SimpleForm>
//     <SelectInput source="Month" choices={[
//         { id: '1', name: 'January' },
//         { id: '2', name: 'Feburary' },
//     ]} />
//     </SimpleForm>
//     </Create>
// );

var d = new Date();
var mnth = d.getMonth();
var yr = d.getFullYear();
// console.log(mnth)

export const ReceiptList = (props) => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    return (
        <List filters={<ReceiptFilter />} aside={<Aside />} filterDefaultValues={{ Month: mnth, Year: yr, RcptType: "All", Paid: "N" }} bulkActionButtons={<ReceiptListActions {...props} />} {...props}>
            {isSmall ? (
                // <SimpleList
                //     primaryText={record => record.StudentName}
                //     secondaryText={record => record.Amt}
                //     tertiaryText={record => record.Paid}
                // />
                <Datagrid>
                    <TextField label="Student Name" source="StudentName" />
                    <TextField label="Amount" source="Amt" />
                    <TextField label="BalanceApplied" source="BalanceApplied" />
                    <TextField label="AmountPaid" source="AmtPaid" />
                    <TextField label="Payment Method" source="PmtMethod" />
                    <TextField label="Billing Date" source="BillingDate" />
                    <TextField label="Email Sent" source="EmailSent" />
                    <TextField label="Type" source="Rcpttype" />
                    <TextField label="Extra Hours" source="ExtraHrs" />
                    <TextField label="Month" source="Month" />
                    <TextField label="Year" source="Year" />
                    <TextField label="Paid" source="Paid" />
                    <EditButton />
                    {/* <ReceiptEditButton /> */}
                </Datagrid>
            ) : (
                <Datagrid>
                    <TextField label="Student Name" source="StudentName" />
                    <TextField label="Amount" source="Amt" />
                    <TextField label="BalanceApplied" source="BalanceApplied" />
                    <TextField label="AmountPaid" source="AmtPaid" />
                    <TextField label="Payment Method" source="PmtMethod" />
                    <TextField label="Reg Amount" source="Regamt" />
                    <TextField label="Material Amount" source="Materialamt" />
                    <TextField label="Billing Date" source="BillingDate" />
                    <TextField label="Paid Date" source="PaidDate" />
                    <TextField label="Payment ID" source="PID" />
                    <TextField label="Email Sent" source="EmailSent" />
                    <TextField label="Type" source="Rcpttype" />
                    <TextField label="Extra Hours" source="ExtraHrs" />
                    <TextField label="Registration Year" source="RegYear" />
                    <TextField label="Month" source="Month" />
                    <TextField label="Year" source="Year" />
                    <TextField label="Paid" source="Paid" />
                    <TextField label="Notes" source="Notes" />
                    <EditButton />
                    {/* <ReceiptEditButton /> */}
                </Datagrid>)}
        </List>
    );
};

const ReceiptTitle = ({ record }) => {
    return <span>Receipt {record ? `"${record.id}"` : ''}</span>;
};

export const ReceiptEdit = (props) => (
    <Edit title={<ReceiptTitle />} {...props}>
        <SimpleForm>
            <TextInput disabled label="Id" source="id" />
            <TextInput label="Name" source="Name" />
            <TextInput disabled label="Student Name" source="StudentName" />
            <TextInput label="Parent's Names" source="ParentNames" />
            <TextInput label="Item" source="Item" />
            <TextInput label="Amount" source="Amt" />
            <SelectInput label="Paid" source="Paid" choices={[
                { id: 'Y', name: 'Y' },
                { id: 'N', name: 'N' },
            ]} />
            <TextInput label="AmountPaid" source="AmtPaid" />
            <TextInput label="Balance Applied" source="BalanceApplied" />
            <SelectInput label="Payment Method" source="PmtMethod" choices={[
                { id: 'venmo', name: 'Venmo' },
                { id: 'cash', name: 'Cash' },
                { id: 'check', name: 'Check' }
            ]} />
            <TextInput label="Billing Date" source="BillingDate" />
            <TextInput disabled label="Receipt Type" source="Rcpttype" />
            <TextInput label="Extra Hours" source="ExtraHrs" />
            <TextInput label="Month" source="Month" />
            <TextInput label="Year" source="Year" />
            <TextInput label="Reg Year" source="RegYear" />
            <TextInput disabled label="Email Sent" source="EmailSent" />
            <TextInput label="Notes" source="Notes" />
        </SimpleForm>
    </Edit>
);

const ReceiptListActions = props => (
    <TopToolbar>
        <BulkDeleteButton {...props} undoable="true" /><MyTab /><MyTab /><MyTab /><MyTab />
        {/* <CreateButton basePath={basePath} record={data} /> */}
        {/* Add your custom actions */}
        <SetPaidButtonCash {...props} />
        <SetPaidButtonCheck {...props} />
        <SendEmailButton {...props} />
        <ExtraHrsButton {...props} />
        <CreateFeeReminderEmailButton {...props} />

    </TopToolbar>
);
